import gql from 'graphql-tag'
import client from '@stores/apollo'
import { FetchResult } from 'apollo-link'
import { IAssetTag } from '@api/types'

export type IAsset = {
  viewer: {
    company: {
      assetTags: {
        edges: {
          node: IAssetTag
        }
      }
    }
  }
}

export default function fetchAssetTags(): Promise<FetchResult<IAsset>> {
  return client.gql.query({ query })
}

const query = gql`
  query {
    viewer {
      company {
        assetTags {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`
